import { mergeProps as _mergeProps, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e58e45c"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["value"]
const _hoisted_2 = ["accept"]
const _hoisted_3 = ["title"]
const _hoisted_4 = {
  key: 0,
  class: "spinner-border text-secondary mx-auto"
}
const _hoisted_5 = {
  key: 0,
  class: "mt-1 mb-0 w-100"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = {
  key: 2,
  class: "invalid-feedback text-danger fw-bold mb-0"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  for: "",
  class: "form-control form-control-solid"
}
const _hoisted_10 = { key: 2 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    (!_ctx.isReadOnly)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(["input-group has-validation mb-2", { 'no-click': _ctx.settings.attributes.disabled }])
        }, [
          _createElementVNode("input", _mergeProps(_ctx.attributes, {
            class: ["form-control form-control-solid", { 'is-invalid': _ctx.validationState?.$error || _ctx.error }],
            value: _ctx.name ?? '',
            onKeydown: _cache[0] || (_cache[0] = (event) => event.preventDefault()),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$refs[_ctx.ref].click()))
          }), null, 16, _hoisted_1),
          _createElementVNode("input", {
            ref: _ctx.ref,
            type: "file",
            class: "d-none",
            accept: _ctx.acceptAttr,
            onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.getFile && _ctx.getFile(...args)))
          }, null, 40, _hoisted_2),
          _createElementVNode("span", {
            class: "input-group-text cursor-pointer show-dialog-button",
            "data-bs-toggle": "tooltip",
            "data-bs-placement": "right",
            title: _ctx.hasFile ? 'Remover' : 'Cargar',
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.hasFile ? _ctx.clear() : _ctx.$refs[_ctx.ref].click()))
          }, [
            (_ctx.loading)
              ? (_openBlock(), _createElementBlock("span", _hoisted_4))
              : (_openBlock(), _createBlock(_component_font_awesome_icon, {
                  key: 1,
                  icon: _ctx.icon,
                  size: "lg",
                  class: "mx-auto"
                }, null, 8, ["icon"]))
          ], 8, _hoisted_3),
          (_ctx.validationState?.$errors?.length)
            ? (_openBlock(), _createElementBlock("ul", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.validationState.$errors, (error) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: error.$uid,
                    class: "text-danger fw-bold mb-0"
                  }, _toDisplayString(error.$message), 1))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (_ctx.serverErrors.length)
            ? (_openBlock(), _createElementBlock("ul", {
                key: 1,
                class: _normalizeClass(["mb-0", { 'mt-1': !_ctx.validationState?.$errors?.length }])
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.serverErrors, (serverError, index) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: `${_ctx.settings.attributes.name}-error-${index}`,
                    class: "text-danger fw-bold mb-0"
                  }, [
                    _createElementVNode("div", {
                      innerHTML: _ctx.$sanitize(serverError)
                    }, null, 8, _hoisted_6)
                  ]))
                }), 128))
              ], 2))
            : _createCommentVNode("", true),
          (_ctx.error)
            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.error), 1))
            : _createCommentVNode("", true)
        ], 2))
      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
          _createElementVNode("label", _hoisted_9, _toDisplayString(_ctx.value.name), 1)
        ])),
    (_ctx.canPreview)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createElementVNode("span", {
            class: "link-primary link-offset-2 cursor-pointer ms-1",
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.preview && _ctx.preview(...args)))
          }, " Previsualizar ")
        ]))
      : _createCommentVNode("", true)
  ]))
}